export default {
  Data: 1,
  Summary: 2,
}
